export default __webpack_public_path__ + "static/media/038-burj khalifa.939c520a.svg";